export default __webpack_public_path__ + "static/logo-f6808c770ff415b4ffe9a41c5317bb36.png";